import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import landingPageAPI from '../../services/api';
import { getImageUrl } from '../../utils/imageUtils';
import { useLoading } from '../../contexts/LoadingContext';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './HeroCarousel.css';

const HeroCarousel = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [registerLink, setRegisterLink] = useState('/haazri-frontend/#/register');
  const { markComponentLoaded } = useLoading();

  useEffect(() => {
    fetchCarouselSlides();
    fetchRegisterLink();
  }, []);

  const fetchCarouselSlides = async () => {
    try {
      const response = await landingPageAPI.getCarousel();
      if (response.data.status === 'success') {
        setSlides(response.data.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch carousel:', error);
    } finally {
      setLoading(false);
      markComponentLoaded('HeroCarousel');
    }
  };

  const fetchRegisterLink = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const config = response.data.data.config || {};
        if (config.link_register) {
          setRegisterLink(config.link_register);
        }
      }
    } catch (error) {
      console.error('Failed to fetch register link:', error);
    }
  };

  if (loading) {
    return <div className="hero-loading">Loading...</div>;
  }

  if (!slides.length) {
    return (
      <section className="hero-carousel">
        <div className="hero-fallback">
          <div className="hero-content">
            <h1>Smart Attendance Management</h1>
            <p>Transform your workforce management with eHaazri</p>
            <div className="cta-buttons">
              <a href={registerLink} className="btn btn-primary">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="hero-carousel">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        loop={true}
        className="hero-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="slide"
              style={{ backgroundImage: `url(${getImageUrl(slide.image_path)})` }}
            >
              <div className="slide-overlay"></div>
              <div className="slide-content">
                <h1>{slide.title}</h1>
                {slide.subtitle && <p>{slide.subtitle}</p>}
                {slide.link_url && (
                  <div className="cta-buttons">
                    <a href={slide.link_url} className="btn btn-primary">
                      {slide.link_text || 'Learn More'}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HeroCarousel;
